import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { TemplateStructureTreeComponent } from './components/template-structure-tree/template-structure-tree.component';
import { PhonePreviewComponent } from './components/phone-preview/phone-preview.component';
import { FieldPaletteComponent } from './components/field-palette/field-palette.component';
import { FormCanvasComponent } from './components/form-canvas/form-canvas.component';
import { FieldConfigPanelComponent } from './components/field-config-panel/field-config-panel.component';
import { NestedLevelComponent } from './components/nested-level/nested-level.component';

const COMPONENTS = [
  TemplateStructureTreeComponent,
  PhonePreviewComponent,
  // DOCU-1066: Der Form-Builder lag bis dahin nur im Backoffice. Er sitzt hier,
  // damit das AdminPanel Kundenvorlagen im Designer statt im JSON-Feld bearbeiten kann.
  FieldPaletteComponent,
  FormCanvasComponent,
  FieldConfigPanelComponent,
  NestedLevelComponent,
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatTooltipModule,
    // Die Builder-Templates sind durchgängig übersetzt (FORM_BUILDER.*). Die
    // Keys liefert die konsumierende App, nicht die Library.
    TranslateModule,
  ],
  exports: [...COMPONENTS],
})
export class DocutyTemplateRendererModule {}
